import _ from "lodash";

export const formatLearnerForm = (data) => {
	let formatted = {};
	Object.entries(data).forEach((value) => {
		formatted[value[0]] = { value: value[1] };
	});
	return formatted;
};

export const formatCustomForm = (data) => {
	let formatted = [];
	Object.entries(data).forEach((value) => {
        formatted.push({
            skipped: !value[1] || value[1] === "",
            value: !value[1] ? "" : value[1],
            _id: value[0]
        })
	});
	return formatted;
};

// to randomized an array
export const makeArrayRandom = (array)  => {
	return _(array)
		.map((el) => {
			return el;
		})
		.shuffle()
		.each((el, index) => array[index] = el);
}
